import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="location-toggle"
export default class extends Controller {
  static targets = ["inPersonFields"]

  connect() {
    this.syncFromCheckedDeliveryMethod()
  }

  toggle(event) {
    const online = event.target.value === "online"
    if (this.hasInPersonFieldsTarget) {
      this.inPersonFieldsTarget.classList.toggle("hidden", online)
    }
  }

  syncFromCheckedDeliveryMethod() {
    const checked = this.element.querySelector('input[name="service[delivery_method]"]:checked')
    if (!checked || !this.hasInPersonFieldsTarget) return
    this.inPersonFieldsTarget.classList.toggle("hidden", checked.value === "online")
  }
}
